import React from 'react'
import { VndlyPositionIssuesProvider } from './context/VndlyPositionIssuesProvider'
import { VndlyPositionIssuesMain } from './components/VndlyPositionIssuesMain'

export const VndlyPositionIssues = () => {
  return (
    <VndlyPositionIssuesProvider>
      <VndlyPositionIssuesMain />
    </VndlyPositionIssuesProvider>
  )
}
